import { createFileRoute } from '@tanstack/react-router'
import { AppUserShow } from '@/features/app-users/pages/app-user-show'

export const Route = createFileRoute('/_authenticated/app-users/$appUserId/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { appUserId } = Route.useParams()
  return <AppUserShow appUserId={appUserId} />
}
